// fitText - https://github.com/adactio/FitText.js
!(function () {
  var n = function (n, t, e) {
      n.addEventListener
        ? n.addEventListener(t, e, !1)
        : n.attachEvent("on" + t, e);
    },
    t = function (n, t) {
      for (var e in t) t.hasOwnProperty(e) && (n[e] = t[e]);
      return n;
    };
  window.fitText = function (e, i, o) {
    var r = t({ minFontSize: -1 / 0, maxFontSize: 1 / 0 }, o),
      a = function (t) {
        var e = i || 1,
          o = function () {
            t.style.fontSize =
              Math.max(
                Math.min(t.clientWidth / (10 * e), parseFloat(r.maxFontSize)),
                parseFloat(r.minFontSize)
              ) + "px";
          };
        o(), n(window, "resize", o), n(window, "orientationchange", o);
      };
    if (e.length) for (var f = 0; f < e.length; f++) a(e[f]);
    else a(e);
    return e;
  };
})();

if (document.querySelector(".video-hero__logo h1")) {
  fitText(document.querySelector(".video-hero__logo h1"), 0.53);
}

// adjust the size of text on the hero responsive section
const heroTitles = document.querySelectorAll("[data-hero-responsive] h1");
if (heroTitles.length > 0) {
  heroTitles.forEach((title) => {
    fitText(title, 0.53);
  });
}

if (document.querySelector(".video-hero__heading-container h1")) {
  fitText(document.querySelector(".video-hero__heading-container h1"), 0.68);
}

if (document.querySelector(".product-content h1")) {
  fitText(document.querySelector(".product-content h1"), 0.75);
}

const question = document.querySelector(".accordian__item__question");
const itemQuestionIcon = document.querySelector(
  ".accordian__item__question__icon"
);
if (question) {
  question.addEventListener("click", function () {
    // question.parentElement.classList.toggle('accordian__item--open');
    if (itemQuestionIcon.textContent == "+") {
      itemQuestionIcon.textContent = "-";
    } else {
      itemQuestionIcon.textContent = "+";
    }
  });
}

const nutritional_popup = document.querySelector(".nutritional__popup-close");
if (nutritional_popup) {
  nutritional_popup.addEventListener("click", function () {
    if (itemQuestionIcon.textContent == "+") {
      itemQuestionIcon.textContent = "-";
    } else {
      itemQuestionIcon.textContent = "+";
    }
  });
}

function isElementInView(element, threshold) {
  var rect = element.getBoundingClientRect();
  var windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;
  return (
    rect.top <= windowHeight - threshold &&
    rect.bottom >= threshold &&
    rect.left <= windowWidth - threshold &&
    rect.right >= threshold
  );
}

// When the specific class comes into view, add the 'visible' class to the pop-up - starts
function checkForPopup() {
  const get_popup = document.querySelector(".popup");
  const popup_overlay = document.querySelector(".popup-overlay");
  if (get_popup == null) {
    return;
  }
  const elementToTriggerPopup = document.querySelector(
    get_popup.getAttribute("data-show")
  );
  const popupID = get_popup.getAttribute("data-id");

  // Check if a cookie exists for closing this already, and if the correct part of the page has been reached.
  if (
    !popupCookieExists(popupID) &&
    get_popup &&
    isElementInView(elementToTriggerPopup, 100)
  ) {
    get_popup.classList.add("visible");
    popup_overlay.classList.add("visible");
  }
}
window.addEventListener("scroll", checkForPopup);
window.addEventListener("resize", checkForPopup);
// When the specific class comes into view, add the 'visible' class to the pop-up - ends

// JS for closing the popup banner
const popupClose = document.querySelector(".popup-close");
const popupScrollButton = document.querySelector(".popup-signup__text");
if (popupClose) {
  popupClose.addEventListener("click", function () {
    hidePopup();
  });
}
if (popupScrollButton) {
  popupScrollButton.addEventListener("click", function () {
    hidePopup();
  });
}

function hidePopup() {
  document.querySelector(".popup").style.display = "none";
  document.querySelector(".popup-overlay").style.display = "none";

  //ADD COOKIE FOR CURRENT POPUP ID
  createPopupCookie(document.querySelector(".popup").getAttribute("data-id"));
}

function createPopupCookie(popupID) {
  document.cookie = `popup_session=${popupID}`;
}

function popupCookieExists(popupID) {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith("popup_session=")) {
      const sessionId = cookie.substring("popup_session=".length);
      if (sessionId === popupID) {
        return true;
      }
    }
  }
  return false;
}

// JS for closing the announcement bar
const announcementBarClose = document.querySelector(
  ".announcement-close-container"
);
if (announcementBarClose) {
  announcementBarClose.addEventListener("click", function () {
    document.querySelector("#shopify-section-announcement-bar").style.display =
      "none";
    document
      .querySelector(".site-header")
      .classList.add("announcement-bar_hidden");
  });
}

// JS for sending to footer newsletter section when clicked on popup banner - starts here
// Get the popup button element
const popupButton = document.querySelector(".popup-button__newsletter");

if (popupButton) {
  // Add a click event listener to the popup button
  popupButton.addEventListener("click", () => {
    // Get the newsletter div element
    const newsletterDiv = document.querySelector(".site-footer__newsletter");
    // Scroll to the newsletter div
    newsletterDiv.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
}
// JS for sending to footer newsletter section when clicked on popup banner - ends here

// Adding an another menu i.e. [Handle: footer-menu-1] inside Main Menu but shows oonly when More button clicked
const menu_more = document.querySelector(".menu__more");
const menu_more_list = document.querySelector(".menu-more__list");
menu_more.addEventListener("click", () => {
  var currentText = menu_more.textContent;
  if (currentText === "More") {
    menu_more.textContent = "Less";
    menu_more_list.style.display = "block";
  } else {
    menu_more.textContent = "More";
    menu_more_list.style.display = "none";
  }
  menu_more_list.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
});
// Adding an another menu i.e. [Handle: footer-menu-1] inside Main Menu but shows oonly when More button clicked

const header = document.querySelector(".site-header");
const nav_trigger = document.querySelector(".nav-trigger--menu");
const site_nav_icons = document.querySelectorAll(".site-nav-icons");
const logo_desktop = document.querySelector(".logo-desktop");
const header_align = document.querySelector(".header-align");
const windowObj = window;

let prevScrollPos = windowObj.scrollY;

function toggleStickyHeader() {
  const currentScrollPos = windowObj.scrollY;
  const isScrollingUp = currentScrollPos < prevScrollPos;
  const isSticky = currentScrollPos > 10;

  if (isSticky) {
    if (isScrollingUp) {
      header.classList.toggle("sticky", isSticky);
      nav_trigger.classList.toggle("sticky", isSticky);
      site_nav_icons.forEach(function (icon) {
        icon.classList.toggle("sticky", isSticky);
      });
      logo_desktop.classList.toggle("sticky", isSticky);
      header_align.classList.toggle("sticky", isSticky);
    } else {
      header.classList.remove("sticky");
      nav_trigger.classList.remove("sticky");
      site_nav_icons.forEach(function (icon) {
        icon.classList.remove("sticky");
      });
      logo_desktop.classList.remove("sticky");
      header_align.classList.remove("sticky");
    }
    header.classList.remove("fixed");
  } else {
    header.classList.remove("sticky");
    nav_trigger.classList.remove("sticky");
    site_nav_icons.forEach(function (icon) {
      icon.classList.remove("sticky");
    });
    logo_desktop.classList.remove("sticky");
    header_align.classList.remove("sticky");
    header.classList.add("fixed");
  }

  prevScrollPos = currentScrollPos;
}

// Get the height of the header
const headerHeight = header.offsetHeight;

// Call the function on page load
toggleStickyHeader();

// Call the function on scroll
window.addEventListener("scroll", toggleStickyHeader);

// Setting custom slider duration data from customize | hero-video.liquid file is where the data is set
/*
const get_slider_duration = window.theme.get_slider_duration;
let set_slider_duration = get_slider_duration * 1000;
const swiper = new Swiper('.hero-reviews', {
    loop: true,
    speed: 400,
    spaceBetween: 100,
    autoplay: {
        delay: set_slider_duration,
    }
});
*/

// Contact Page smooth scroll
const general_enquiry_link = document.querySelector(".general-enquiries__link");
if (general_enquiry_link) {
  general_enquiry_link.addEventListener("click", () => {
    const scroll_to_form = document.querySelector(".contact-subheader");
    scroll_to_form.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
}

// Product Timer
function getRemainingTime(endHour, endMinute, endSecond) {
  const now = new Date();
  const targetDate = new Date();

  // Set the target date to the next day
  targetDate.setDate(targetDate.getDate());

  // Set the target time based on the provided endHour, endMinute, and endSecond
  targetDate.setHours(endHour, endMinute, endSecond, 0);

  // Calculate the difference in milliseconds
  const difference = targetDate - now;

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(difference / (1000 * 60 * 60));
  const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((difference % (1000 * 60)) / 1000);

  return {
    hours,
    minutes,
    seconds,
  };
}

const showMoreButton = document.querySelector("#show-more-recpies");
const showLessButton = document.querySelector("#show-less-recpies");
const recpiesToToggle = document.querySelectorAll(".toggle-on-mobile");
if (showLessButton != null) {
  showLessButton.addEventListener("click", function (e) {
    showLessButton.classList.add("hidden");
    showMoreButton.classList.remove("hidden");
    recpiesToToggle.forEach((item, index) => {
      item.classList.add("small-hide");
    });
  });
}
if (showMoreButton != null) {
  showMoreButton.addEventListener("click", function (e) {
    showMoreButton.classList.add("hidden");
    showLessButton.classList.remove("hidden");
    recpiesToToggle.forEach((item, index) => {
      item.classList.remove("small-hide");
    });
  });
}

const timerCheck = setTimeout(() => {
  const outOfStock = document.querySelector(
    ".product-details__item.out-of-stock"
  );

  if (
    document.querySelector(".trustblox-message") == null &&
    outOfStock == null
  ) {
    const timerWrapper = document.querySelector(".delivery-timer-container");
    if (timerWrapper == null) {
      return;
    }
    document
      .querySelector(".delivery-timer-container")
      .classList.remove("hidden");
    const paragraph = document.createElement("p");
    paragraph.classList.add("order-timer-fallback");
    paragraph.textContent = `Order now to receive on Tuesday`;
    timerWrapper.appendChild(paragraph);
  }
  if (document.querySelector(".trustblox-message") != null) {
    document
      .querySelector(".delivery-timer-container")
      .classList.remove("hidden");
  }
}, 3000);

// If the app loads in too late, check for it and remove the fallback text.
const repeatTimerCheck = setInterval(() => {
  if (document.querySelector(".trustblox-message") != null) {
    if (document.querySelector(".order-timer-fallback") != null) {
      document.querySelector(".order-timer-fallback").classList.add("hidden");
    }
    clearInterval(repeatTimerCheck);
    if (
      document
        .querySelector(".trustblox-instruction")
        .innerHTML.includes("Tuesday")
    ) {
      if (document.querySelector(".order-timer-fallback") != null) {
        document
          .querySelector(".order-timer-fallback")
          .classList.remove("hidden");
      } else {
        const paragraph = document.createElement("p");
        paragraph.classList.add("order-timer-fallback");
        paragraph.textContent = `Order now to receive on Tuesday`;
        document
          .querySelector(".delivery-timer-container")
          .appendChild(paragraph);
      }
      document.querySelector(".trustblox-1-timer-wrap").classList.add("hidden");
    }
  }
}, 500);

setTimeout(function () {
  clearInterval(repeatTimerCheck);
}, 15000);

const newsletter_link = document.querySelector(".popup a");
if (newsletter_link) {
  newsletter_link.addEventListener("click", function (event) {
    event.preventDefault();
    const scroll_element = newsletter_link.getAttribute("href");
    if (scroll_element.includes("#")) {
      document.querySelector(scroll_element).scrollIntoView({
        behavior: "smooth",
      });

      newsletter_link.closest(".popup").style.display = "none";
    }
  });
}

// Function to update the cart count
function updateCartCount() {
  fetch("/cart.js")
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var cartCount = cart.item_count;
      document.getElementById("cart-count-container").innerHTML =
        "(" + cartCount + ")";
    });
}

//Function to Show/Hide the pages on the content community page
const communityLinks = document.querySelectorAll("a[data-community]");
const containers = document.querySelectorAll(
  ".community-text-content[data-community]"
);

// Add click event listeners to the links
communityLinks.forEach((link) => {
  link.addEventListener("click", (event) => {
    event.preventDefault();
    const clickedLinkId = link.getAttribute("data-community");

    // Toggle visibility of containers
    containers.forEach((container) => {
      if (container.getAttribute("data-community") === clickedLinkId) {
        container.style.display = "block";
      } else {
        container.style.display = "none";
      }
    });
    // Add 'active' class to the clicked link and clear from previously active link
    communityLinks.forEach((l) => {
      if (l === link) {
        l.classList.add("active");
      } else {
        l.classList.remove("active");
      }
    });
  });
});

(function matchHeight() {
  //Grab divs with the class name 'match-height'
  var getDivs = document.getElementsByClassName('match-height');

  //Find out how my divs there are with the class 'match-height' 
  var arrayLength = getDivs.length;
  var heights = [];

  //Create a loop that iterates through the getDivs variable and pushes the heights of the divs into an empty array
  for (var i = 0; i < arrayLength; i++) {
    heights.push(getDivs[i].offsetHeight);
  }

  //Find the largest of the divs
  function getHighest() {
    return Math.max(...heights);
  }

  //Set a variable equal to the tallest div
  var tallest = getHighest();

  //Iterate through getDivs and set all their height style equal to the tallest variable
  for (var i = 0; i < getDivs.length; i++) {
    getDivs[i].style.height = tallest + "px";
  }
})();
